import React, { Component } from "react";
import { connect } from "react-redux";

import helpers from "../helpers/index";
import route_helper from "../route-helper";
import NavTop from "../components/nav-top";
import ModalDeleteAccount from "../components/accounts/modal-delete-account";
import TableFilter from "../components/tables/table-filter";
import TableFooter from "../components/tables/table-footer";
import { cloneDeep, debounce, filter } from "lodash";
import settings from "../configs/settings";
import account_api from "../api/user-account-api";
import { radix_bases } from "../helpers/helper-number-bases";
import $ from 'jquery'
import AccountFiltersContainer from '../components/accounts/account-filters-container';
import json_columns from '../components/accounts/columns.json'
import moment from 'moment'
import { createUUID } from '../components/react-flow-pedigree/utils';
import ModalSaveReport from "../components/query/modal-save-report";
import ModalOverwriteReport from '../components/modal-overwrite-report'
import ModalConfirmReportDelete from "../components/modal-confirm-report-delete";
import jsPDF from 'jspdf';

function parseToInt(val) {
  return parseInt(val, radix_bases.base10);
}

let init_filter_state = {
  renewal_date_operator: '=',
  renewal_date_from: null,
  renewal_date_to: null,
  trial_expiration_operator: '=',
  trial_expiration_from: null,
  trial_expiration_to: null,
  locked_unlocked: '',
  account_type: '',
  client_type: ''
}

class AccountsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showDeleteOrgModal: false,
      currentOrgKey: null,
      organizations: [],
      codes: [],
      entries_per_page: 30,
      page: 1,
      deleteErrorMessage: null,
      sortingState: {
        column: "account_name",
        sortOrder: 1,
        clicks: 0
        //sortOrder of 1 is ascending and -1 is descending
        //on third numberOfClicks all sortingState is set to 0
      },
      filters: init_filter_state,
      columns: [],
      allColumns: [],
      reports: [],
      show_save_report_modal: false,
      show_overwrite_report: [false, ''],
      show_delete_report_modal: [false, ''],
      filtered_organizations: [],
    };
    this.openDeleteOrgModal = this.openDeleteOrgModal.bind(this);
    this.closeDeleteOrgModal = this.closeDeleteOrgModal.bind(this);
    this.viewOrgClicked = this.viewOrgClicked.bind(this);

    this.onChange = this.onChange.bind(this);
    this.onDeleteOrg = this.onDeleteOrg.bind(this);

    this.getOrgbyId = this.getOrgbyId.bind(this);

    this.fetchData = this.fetchData.bind(this);

    this.filterValues = this.filterValues.bind(this);
    this.onSearchSubmit = this.onSearchSubmit.bind(this);
    this.handleColumnHeaderClick = this.handleColumnHeaderClick.bind(this);
    this.downloadCSV = this.downloadCSV.bind(this);
    this.clearDeleteMessage = this.clearDeleteMessage.bind(this);
    this.sortItems = this.sortItems.bind(this);
    this.trackScrolling = this.trackScrolling.bind(this);
    this.loadDefaultColumns = this.loadDefaultColumns.bind(this);
    this.onEditColumns = this.onEditColumns.bind(this);
    this.handleReorderColumns = this.handleReorderColumns.bind(this);
    this.fetchReports = this.fetchReports.bind(this);
    this.setShowSaveReportModal = this.setShowSaveReportModal.bind(this);
    this.saveNewReport = this.saveNewReport.bind(this);
    this.openOverwriteReportModal = this.openOverwriteReportModal.bind(this);
    this.closeOverwriteReportModal = this.closeOverwriteReportModal.bind(this);
    this.openDeleteReportModal = this.openDeleteReportModal.bind(this);
    this.loadReport = this.loadReport.bind(this);
    this.handleClearFilter = this.handleClearFilter.bind(this);
    this.copyText = this.copyText.bind(this);
    this.onSavePDF = this.onSavePDF.bind(this);
    this.filterOrganizations = this.filterOrganizations.bind(this);

    this.tableFilterRef = React.createRef();
    this.accountFiltersRef = React.createRef();
  }

  async loadDefaultColumns(){
    let selected_columns
      try{
          this.setState({loading: true})
          let columns = await account_api.load_default_columns(this.props.session.user.organization_id, this.props.session.user.account_id)
          let merged_columns;
          if(columns.default_columns !== null && columns.default_columns !== undefined ){
            merged_columns = [...columns.default_columns]

            const existing_values = new Set(merged_columns.map((c) => c.value))

            json_columns.forEach((col) => {
              if (!existing_values.has(col.value)) {
                merged_columns.forEach((c) => {
                  if (c.order >= col.order) {
                    c.order += 1
                  }
                })
                merged_columns.push(col);
                existing_values.add(col.value);
              }
            });

            merged_columns.sort((a, b) => a.order - b.order);

            // this.columnRef = columns.default_columns
            selected_columns = merged_columns.filter(item => item.checked)

            this.setState({ columns: selected_columns, allColumns: merged_columns})
          }else{
            this.columnRef = json_columns
            this.setState({allColumns: json_columns})
            selected_columns = json_columns.filter(item => item.checked)
            this.setState({ columns: selected_columns})
          }
      }catch(err){
        console.log(err)
      }finally{
        helpers.delay(1)
        this.setState({loading: false})
      }
    }

  handleColumnHeaderClick(column) {
    let sortingState = this.state.sortingState;

    //to handle sortingState changes on clicks
    if (column === sortingState.column && sortingState.clicks === 1) {
      sortingState.clicks = 2
      sortingState.sortOrder = -1
    } else if (column === sortingState.column && sortingState.clicks === 2) {
      sortingState.clicks = 0
      sortingState.sortOrder = 1
      sortingState.column = "account_name"
    } else {
      sortingState.clicks = 1
      sortingState.sortOrder = 1
      sortingState.column = column
    }
    this.setState({sortingState: sortingState})
    let items = this.sortItems(sortingState);
    this.setState({organizations: items})
  }

  getLocaleDateString() {
    var formats = { "ar-SA": "DD/MM/YY", "bg-BG": "DD.MM.YYYY", "ca-ES": "DD/MM/YYYY", "zh-TW": "YYYY/MM/DD", "cs-CZ": "DD.MM.YYYY", "da-DK": "DD-MM-YYYY", "de-DE": "DD.MM.YYYY", "el-GR": "DD/MM/YYYY", "en-US": "MM/DD/YYYY", "fi-FI": "DD.MM.YYYY", "fr-FR": "DD/MM/YYYY", "he-IL": "DD/MM/YYYY", "hu-HU": "YYYY. MM. DD.", "is-IS": "DD.MM.YYYY", "it-IT": "DD/MM/YYYY", "ja-JP": "YYYY/MM/DD", "ko-KR": "YYYY-MM-DD", "nl-NL": "DD-MM-YYYY", "nb-NO": "DD.MM.YYYY", "pl-PL": "YYYY-MM-DD", "pt-BR": "DD/MM/YYYY", "ro-RO": "DD.MM.YYYY", "ru-RU": "DD.MM.YYYY", "hr-HR": "DD.MM.YYYY", "sk-SK": "DD. MM. YYYY", "sq-AL": "YYYY-MM-DD", "sv-SE": "YYYY-MM-DD", "th-TH": "DD/MM/YYYY", "tr-TR": "DD.MM.YYYY", "ur-PK": "DD/MM/YYYY", "id-ID": "DD/MM/YYYY", "uk-UA": "DD.MM.YYYY", "be-BY": "DD.MM.YYYY", "sl-SI": "DD.MM.YYYY", "et-EE": "DD.MM.YYYY", "lv-LV": "YYYY.MM.DD.", "lt-LT": "YYYY.MM.DD", "fa-IR": "MM/DD/YYYY", "vi-VN": "DD/MM/YYYY", "hy-AM": "DD.MM.YYYY", "az-Latn-AZ": "DD.MM.YYYY", "eu-ES": "YYYY/MM/DD", "mk-MK": "DD.MM.YYYY", "af-ZA": "YYYY/MM/DD", "ka-GE": "DD.MM.YYYY", "fo-FO": "DD-MM-YYYY", "hi-IN": "DD-MM-YYYY", "ms-MY": "DD/MM/YYYY", "kk-KZ": "DD.MM.YYYY", "ky-KG": "DD.MM.YY", "sw-KE": "MM/DD/YYYY", "uz-Latn-UZ": "DD/MM YYYY", "tt-RU": "DD.MM.YYYY", "pa-IN": "DD-MM-YY", "gu-IN": "DD-MM-YY", "ta-IN": "DD-MM-YYYY", "te-IN": "DD-MM-YY", "kn-IN": "DD-MM-YY", "mr-IN": "DD-MM-YYYY", "sa-IN": "DD-MM-YYYY", "mn-MN": "YY.MM.DD", "gl-ES": "DD/MM/YY", "kok-IN": "DD-MM-YYYY", "syr-SY": "DD/MM/YYYY", "dv-MV": "DD/MM/YY", "ar-IQ": "DD/MM/YYYY", "zh-CN": "YYYY/MM/DD", "de-CH": "DD.MM.YYYY", "en-GB": "DD/MM/YYYY", "es-MX": "DD/MM/YYYY", "fr-BE": "DD/MM/YYYY", "it-CH": "DD.MM.YYYY", "nl-BE": "DD/MM/YYYY", "nn-NO": "DD.MM.YYYY", "pt-PT": "DD-MM-YYYY", "sr-Latn-CS": "DD.MM.YYYY", "sv-FI": "DD.MM.YYYY", "az-Cyrl-AZ": "DD.MM.YYYY", "ms-BN": "DD/MM/YYYY", "uz-Cyrl-UZ": "DD.MM.YYYY", "ar-EG": "DD/MM/YYYY", "zh-HK": "DD/MM/YYYY", "de-AT": "DD.MM.YYYY", "en-AU": "DD/MM/YYYY", "es-ES": "DD/MM/YYYY", "fr-CA": "YYYY-MM-DD", "sr-Cyrl-CS": "DD.MM.YYYY", "ar-LY": "DD/MM/YYYY", "zh-SG": "DD/MM/YYYY", "de-LU": "DD.MM.YYYY", "en-CA": "DD/MM/YYYY", "es-GT": "DD/MM/YYYY", "fr-CH": "DD.MM.YYYY", "ar-DZ": "DD-MM-YYYY", "zh-MO": "DD/MM/YYYY", "de-LI": "DD.MM.YYYY", "en-NZ": "DD/MM/YYYY", "es-CR": "DD/MM/YYYY", "fr-LU": "DD/MM/YYYY", "ar-MA": "DD-MM-YYYY", "en-IE": "DD/MM/YYYY", "es-PA": "MM/DD/YYYY", "fr-MC": "DD/MM/YYYY", "ar-TN": "DD-MM-YYYY", "en-ZA": "YYYY/MM/DD", "es-DO": "DD/MM/YYYY", "ar-OM": "DD/MM/YYYY", "en-JM": "DD/MM/YYYY", "es-VE": "DD/MM/YYYY", "ar-YE": "DD/MM/YYYY", "en-029": "MM/DD/YYYY", "es-CO": "DD/MM/YYYY", "ar-SY": "DD/MM/YYYY", "en-BZ": "DD/MM/YYYY", "es-PE": "DD/MM/YYYY", "ar-JO": "DD/MM/YYYY", "en-TT": "DD/MM/YYYY", "es-AR": "DD/MM/YYYY", "ar-LB": "DD/MM/YYYY", "en-ZW": "MM/DD/YYYY", "es-EC": "DD/MM/YYYY", "ar-KW": "DD/MM/YYYY", "en-PH": "MM/DD/YYYY", "es-CL": "DD-MM-YYYY", "ar-AE": "DD/MM/YYYY", "es-UY": "DD/MM/YYYY", "ar-BH": "DD/MM/YYYY", "es-PY": "DD/MM/YYYY", "ar-QA": "DD/MM/YYYY", "es-BO": "DD/MM/YYYY", "es-SV": "DD/MM/YYYY", "es-HN": "DD/MM/YYYY", "es-NI": "DD/MM/YYYY", "es-PR": "DD/MM/YYYY", "am-ET": "DD/MM/YYYY", "tzm-Latn-DZ": "DD-MM-YYYY", "iu-Latn-CA": "DD/MM/YYYY", "sma-NO": "DD.MM.YYYY", "mn-Mong-CN": "YYYY/MM/DD", "gd-GB": "DD/MM/YYYY", "en-MY": "DD/MM/YYYY", "prs-AF": "DD/MM/YY", "bn-BD": "DD-MM-YY", "wo-SN": "DD/MM/YYYY", "rw-RW": "MM/DD/YYYY", "qut-GT": "DD/MM/YYYY", "sah-RU": "MM.DD.YYYY", "gsw-FR": "DD/MM/YYYY", "co-FR": "DD/MM/YYYY", "oc-FR": "DD/MM/YYYY", "mi-NZ": "DD/MM/YYYY", "ga-IE": "DD/MM/YYYY", "se-SE": "YYYY-MM-DD", "br-FR": "DD/MM/YYYY", "smn-FI": "DD.MM.YYYY", "moh-CA": "MM/DD/YYYY", "arn-CL": "DD-MM-YYYY", "ii-CN": "YYYY/mM/DD", "dsb-DE": "DD. MM. YYYY", "ig-NG": "DD/MM/YYYY", "kl-GL": "DD-MM-YYYY", "lb-LU": "DD/MM/YYYY", "ba-RU": "DD.MM.YY", "nso-ZA": "YYYY/MM/DD", "quz-BO": "DD/MM/YYYY", "yo-NG": "DD/MM/YYYY", "ha-Latn-NG": "DD/MM/YYYY", "fil-PH": "MM/DD/YYYY", "ps-AF": "DD/MM/YY", "fy-NL": "DD-MM-YYYY", "ne-NP": "MM/DD/YYYY", "se-NO": "DD.MM.YYYY", "iu-Cans-CA": "DD/MM/YYYY", "sr-Latn-RS": "DD.MM.YYYY", "si-LK": "YYYY-MM-DD", "sr-Cyrl-RS": "DD.MM.YYYY", "lo-LA": "DD/MM/YYYY", "km-KH": "YYYY-MM-DD", "cy-GB": "DD/MM/YYYY", "bo-CN": "YYYY/MM/DD", "sms-FI": "DD.MM.YYYY", "as-IN": "DD-MM-YYYY", "ml-IN": "DD-MM-YY", "en-IN": "DD-MM-YYYY", "or-IN": "DD-MM-YY", "bn-IN": "DD-MM-YY", "tk-TM": "DD.MM.YY", "bs-Latn-BA": "DD.MM.YYYY", "mt-MT": "DD/MM/YYYY", "sr-Cyrl-ME": "DD.MM.YYYY", "se-FI": "DD.MM.YYYY", "zu-ZA": "YYYY/MM/DD", "xh-ZA": "YYYY/MM/DD", "tn-ZA": "YYYY/MM/DD", "hsb-DE": "DD. MM. YYYY", "bs-Cyrl-BA": "DD.MM.YYYY", "tg-Cyrl-TJ": "DD.MM.YY", "sr-Latn-BA": "DD.MM.YYYY", "smj-NO": "DD.MM.YYYY", "rm-CH": "DD/MM/YYYY", "smj-SE": "YYYY-MM-DD", "quz-EC": "DD/MM/YYYY", "quz-PE": "DD/MM/YYYY", "hr-BA": "DD.MM.YYYY.", "sr-Latn-ME": "DD.MM.YYYY", "sma-SE": "YYYY-MM-DD", "en-SG": "DD/MM/YYYY", "ug-CN": "YYYY-MM-DD", "sr-Cyrl-BA": "DD.MM.YYYY", "es-US": "MM/DD/YYYY" }
    return formats[navigator.language] || 'DD/MM/YYYY';
  }

  sortItems(sortingState) {
    const code_options = this.state.codes;
    let cloned = cloneDeep(this.state.organizations);

    cloned.sort((a, b) => {
      if (sortingState.column == "account_name") {
        return a.org_name.localeCompare(b.org_name) * sortingState.sortOrder;
      } else if (sortingState.column == "clinician_code") {
        let codeA = code_options.find((code) => {
          return parseToInt(code.id) === parseToInt(a.clinician_id);
        });
        codeA = codeA ? codeA.code : '';
        let codeB = code_options.find((code) => {
          return parseToInt(code.id) === parseToInt(b.clinician_id);
        });
        codeB = codeB ? codeB.code : '';
        return codeA.localeCompare(codeB) * sortingState.sortOrder;
      }
      else if (sortingState.column == "account_type") {
        let a_org_type = null;
        let b_org_type = null;
        switch (a.org_type) {
          case 'super_org': { a_org_type = settings.app_constants.superOrg.label; break; }
          case 'sub_org': { a_org_type = settings.app_constants.subOrg.label; break; }
          case 'standard_org': { a_org_type = settings.app_constants.standardOrg.label; break; }
          case 'trial_org': { a_org_type = settings.app_constants.trialOrg.label; break; }
          case 'free': { a_org_type = settings.app_constants.freeOrg.label; break; }
          case 'student': { a_org_type = settings.app_constants.studentOrg.label; break; }
          default: { break; }
        }
        switch (b.org_type) {
          case 'super_org': { b_org_type = settings.app_constants.superOrg.label; break; }
          case 'sub_org': { b_org_type = settings.app_constants.subOrg.label; break; }
          case 'standard_org': { b_org_type = settings.app_constants.standardOrg.label; break; }
          case 'trial_org': { b_org_type = settings.app_constants.trialOrg.label; break; }
          case 'free': { b_org_type = settings.app_constants.freeOrg.label; break; }
          case 'student': { b_org_type = settings.app_constants.studentOrg.label; break; }
          default: { break; }
        }
        a_org_type = a_org_type ? a_org_type : '';
        b_org_type = b_org_type ? b_org_type : '';
        return a_org_type.localeCompare(b_org_type) * sortingState.sortOrder;
      }
      else if (sortingState.column == "renewal_date"){
        if (!a.renewal_date){
          return +1
        }
        if (!b.renewal_date){
          return -1
        }
        let a_renewal_date = new Date(a.renewal_date)
        let b_renewal_date = new Date(b.renewal_date)

        return (a_renewal_date-b_renewal_date) * sortingState.sortOrder;
      }
      else if (sortingState.column == "renewal_amount") {
        if (!a.renewal_amount){
          return +1
        }
        if (!b.renewal_amount){
          return -1
        }
        return (a.renewal_amount-b.renewal_amount) * sortingState.sortOrder;
      }
      else if (sortingState.column == "parent_org") {
        let parentA;
        let parentB;
        if (a.parent_org) {
          parentA = this.getOrgbyId(a.parent_org);
        } else if (!a.parent_org) {
          return +1
        }
        if (b.parent_org) {
          parentB = this.getOrgbyId(b.parent_org)
        } else if (!b.parent_org) {
          return -1
        }
        return parentA.org_name.localeCompare(parentB.org_name) * sortingState.sortOrder;
      }
      else if (sortingState.column == "licenses") {
        if (!a.number_of_licenses) {
          return +1
        }
        if (b.number_of_licenses == null || b.number_of_licenses == undefined) {
          return -1
        }
        return (a.number_of_licenses-b.number_of_licenses) * sortingState.sortOrder;
      }
      else if (sortingState.column == "pedigrees") {
        return (a.pedigrees-b.pedigrees) * sortingState.sortOrder;
      }
      else if (sortingState.column == "contract_date") {
        if (!a.contract_start_date){
          return +1
        }
        if (!b.contract_start_date){
          return -1
        }
        let a_contract_start_date = new Date(a.contract_start_date)
        let b_contract_start_date = new Date(b.contract_start_date)

        return (a_contract_start_date-b_contract_start_date) * sortingState.sortOrder;
      }
      else if (sortingState.column == "specialty") {
        if (!a.specialty){
          return +1
        }
        if (!b.specialty){
          return -1
        }

        return a.specialty.localeCompare(b.specialty) * sortingState.sortOrder;
      }
      else if (sortingState.column == "client_type") {
        let a_client_type = null;
        let b_client_type = null;
        switch (a.client_type) {
          case 'white_label_vpc': { a_client_type = settings.app_constants.clientTypes.white_label_vpc.label; break; }
          case 'white_label_multi_tenant': { a_client_type = settings.app_constants.clientTypes.white_label_multi_tenant.label; break; }
          case 'standard': { a_client_type = settings.app_constants.clientTypes.standard.label; break; }
          default: { break; }
        }
        switch (b.client_type) {
          case 'white_label_vpc': { b_client_type = settings.app_constants.clientTypes.white_label_vpc.label; break; }
          case 'white_label_multi_tenant': { b_client_type = settings.app_constants.clientTypes.white_label_multi_tenant.label; break; }
          case 'standard': { b_client_type = settings.app_constants.clientTypes.standard.label; break; }
          default: { break; }
        }
        if (!a.client_type){
          return +1
        }
        if (!b.client_type){
          return -1
        }

        return a_client_type.localeCompare(b_client_type) * sortingState.sortOrder;
      }
      else if (sortingState.column == "trial_expiration_date") {
        // trial expiration date for org (to be added to org fields)
        if (!a.trial_expiration_date){
          return +1
        }
        if (!b.trial_expiration_date){
          return -1
        }
        let a_trial_expiration_date = new Date(a.trial_expiration_date)
        let b_trial_expiration_date = new Date(b.trial_expiration_date)

        return (a_trial_expiration_date-b_trial_expiration_date) * sortingState.sortOrder;
      }
    });
    return cloned
  }

  async componentDidMount() {
    helpers.setSiteTitle("Accounts");
    await this.loadDefaultColumns();
    await this.fetchReports();
    await this.fetchData();
    window.addEventListener('scroll', debounce(this.trackScrolling, 100), true);
    const sortedOrgs = this.sortItems(this.state.sortingState)
    this.setState({organizations: sortedOrgs})
  }

  async componentWillUnmount() {
    window.removeEventListener('scroll', debounce(this.trackScrolling, 100), true);
  }

  async fetchReports() {
    try{
      let reports = await account_api.get_reports(this.props.session.user.organization_id, this.props.session.user.account_id);
      this.setState({reports: reports})
    } catch(error){
      console.log(error.stack)
    }
  }

  async fetchData() {
    try {

      const codes = await account_api.get_clinician_codes();
      this.setState({ codes });

      const organizations = await account_api.get_orgs();
      this.setState({ organizations });

    } catch (error) {
      console.log(error);
    }
  }

  getDocHeight() {
    var D = document;
    return Math.max(
        D.body.scrollHeight, D.documentElement.scrollHeight,
        D.body.offsetHeight, D.documentElement.offsetHeight,
        D.body.clientHeight, D.documentElement.clientHeight
    );
  }

  async trackScrolling() {

    if($(window).scrollTop() + $(window).height() > this.getDocHeight() - 100) {
      console.log("bottom!");
      let page = this.state.page
      this.setState({ page: page + 1 })
    } else {
      console.log('not at bottom');
    }

  }

  async openDeleteOrgModal(event) {
    this.setState({
      showDeleteOrgModal: true,
      currentOrgKey: event.currentTarget.name,
    });
  }

  closeDeleteOrgModal(event) {
    this.setState({
      showDeleteOrgModal: false,
      currentOrgKey: null,
    });
  }

  async onChange(event) {
    const name = event.target.name;

    const cloned = cloneDeep(this.state.organizations);
    let target_org = null;
    const new_orgs = cloned.map((org) => {
      if (parseToInt(org.id) === parseToInt(name)) {
        org.is_locked = event.target.checked;
        target_org = org;
      }
      return org;
    });

    if (target_org) {
      // send saved data to the server
      const json = {
        org_name: target_org.org_name,
        org_type: target_org.org_type,
        units: target_org.units,
        password_reset_timeframe: target_org.password_reset_timeframe,
        auto_logout_time: target_org.auto_logout_time,
        logo: target_org.logo,
        is_locked: target_org.is_locked,
        parent_org: target_org.parent_org,
      };

      try {
        let response = await account_api.patch_organization(
          target_org.id,
          json
        );

        this.setState({ organizations: new_orgs });
      } catch (error) {
        console.log(error);
      }
    }
  }

  async onDeleteOrg(org_id) {
    if (parseToInt(org_id)) {
      try {
        await account_api.delete_org(org_id);

        const cloned = cloneDeep(this.state.organizations);
        const new_orgs = cloned.filter((org) => {
          if (parseToInt(org.id) !== parseToInt(org_id)) {
            return org;
          }
        });

        this.setState({ organizations: new_orgs });
      } catch (error) {
        this.setState({ deleteErrorMessage: error.message });
        const clearMessage = this.clearDeleteMessage;
        setTimeout(function () {
          clearMessage();
        }, 5000);
      }
    }
  }

  clearDeleteMessage() {
    this.setState({ deleteErrorMessage: null });
  }

  async viewOrgClicked(event) {
    const org_id = event.currentTarget.name;

    let org = this.getOrgbyId(org_id);
    if (org) {
      let url = route_helper.administrative.fh_sub_account.replace(
        ":org_id",
        org_id
      );
      if (org.org_type !== settings.app_constants.subOrg.value) {
        url = route_helper.administrative.fh_super_account.replace(
          ":org_id",
          org_id
        );
      }
      this.props.history.push(url);
    }
  }

  getOrgbyId(id) {
    const org = this.state.organizations.find((org) => {
      return parseToInt(org.id) === parseToInt(id);
    });
    return (org) ? org : null;
  }

  getDateString(date) {
    let month = date.getMonth() + 1;
    let day = date.getDate();
    let date_string =
      date.getFullYear() +
      "-" +
      month.toString().padStart(2, "0") +
      "-" +
      day.toString().padStart(2, "0");

    return date_string
  }

  filterOrganizations(organizations) {
    // renewal date filters
    if (this.state.filters.renewal_date_operator) {
      if (this.state.filters.renewal_date_operator == '=' && this.state.filters.renewal_date_from) {
        organizations = organizations.filter(org => {
          let org_renewal_date = new Date(org.renewal_date).toDateString()
          let filter_renewal_date = new Date(this.state.filters.renewal_date_from).toDateString()
          if (org_renewal_date == filter_renewal_date) {
            return true;
          }
          return false;
        })
      }

      else if (this.state.filters.renewal_date_operator == '<=' && this.state.filters.renewal_date_from) {
        organizations = organizations.filter(org => {
          if (!org.renewal_date) {
            return false;
          }
          let org_renewal_date = new Date(org.renewal_date)
          let filter_renewal_date = new Date(this.state.filters.renewal_date_from)

          let string_org_renewal_date = this.getDateString(org_renewal_date)
          org_renewal_date = new Date(string_org_renewal_date)

          let string_filter_renewal_date = this.getDateString(filter_renewal_date)
          filter_renewal_date = new Date(string_filter_renewal_date)

          if (org_renewal_date <= filter_renewal_date) {
            return true;
          }
          return false
        })
      }

      else if (this.state.filters.renewal_date_operator == '<' && this.state.filters.renewal_date_from) {
        organizations = organizations.filter(org => {
          if (!org.renewal_date) {
            return false;
          }
          let org_renewal_date = new Date(org.renewal_date)
          let filter_renewal_date = new Date(this.state.filters.renewal_date_from)

          let string_org_renewal_date = this.getDateString(org_renewal_date)
          org_renewal_date = new Date(string_org_renewal_date)

          let string_filter_renewal_date = this.getDateString(filter_renewal_date)
          filter_renewal_date = new Date(string_filter_renewal_date)

          if (org_renewal_date < filter_renewal_date) {
            return true;
          }
          return false
        })
      }

      else if (this.state.filters.renewal_date_operator == '>' && this.state.filters.renewal_date_from) {
        organizations = organizations.filter(org => {
          if (!org.renewal_date) {
            return false;
          }
          let org_renewal_date = new Date(org.renewal_date)
          let filter_renewal_date = new Date(this.state.filters.renewal_date_from)

          let string_org_renewal_date = this.getDateString(org_renewal_date)
          org_renewal_date = new Date(string_org_renewal_date)

          let string_filter_renewal_date = this.getDateString(filter_renewal_date)
          filter_renewal_date = new Date(string_filter_renewal_date)

          if (org_renewal_date > filter_renewal_date) {
            return true;
          }
          return false
        })
      }

      else if (this.state.filters.renewal_date_operator == '>=' && this.state.filters.renewal_date_from) {
        organizations = organizations.filter(org => {
          if (!org.renewal_date) {
            return false;
          }
          let org_renewal_date = new Date(org.renewal_date)
          let filter_renewal_date = new Date(this.state.filters.renewal_date_from)

          let string_org_renewal_date = this.getDateString(org_renewal_date)
          org_renewal_date = new Date(string_org_renewal_date)

          let string_filter_renewal_date = this.getDateString(filter_renewal_date)
          filter_renewal_date = new Date(string_filter_renewal_date)

          if (org_renewal_date >= filter_renewal_date) {
            return true;
          }
          return false
        })
      }

      else if (this.state.filters.renewal_date_operator == 'between' && this.state.filters.renewal_date_from && this.state.filters.renewal_date_to) {
        organizations = organizations.filter(org => {
          if (!org.renewal_date) {
            return false;
          }
          let org_renewal_date = new Date(org.renewal_date)
          let renewal_date_from = new Date(this.state.filters.renewal_date_from)
          let renewal_date_to = new Date(this.state.filters.renewal_date_to)

          let string_org_renewal_date = this.getDateString(org_renewal_date)
          org_renewal_date = new Date(string_org_renewal_date)

          let string_renewal_date_from = this.getDateString(renewal_date_from)
          renewal_date_from = new Date(string_renewal_date_from)

          let string_renewal_date_to = this.getDateString(renewal_date_to)
          renewal_date_to = new Date(string_renewal_date_to)

          if (org_renewal_date >= renewal_date_from && org_renewal_date <= renewal_date_to) {
            return true;
          }
          return false
        })
      }
    }

    // trial expirate date filters
    if (this.state.filters.trial_expiration_operator) {
      if (this.state.filters.trial_expiration_operator == '=' && this.state.filters.trial_expiration_from) {
        organizations = organizations.filter(org => {
          let org_trial_expiration_date = new Date(org.trial_expiration_date).toDateString()
          let filter_trial_expiration_date = new Date(this.state.filters.trial_expiration_from).toDateString()
          if (org_trial_expiration_date == filter_trial_expiration_date) {
            return true;
          }
          return false;
        })
      }

      else if (this.state.filters.trial_expiration_operator == '<=' && this.state.filters.trial_expiration_from) {
        organizations = organizations.filter(org => {
          if (!org.trial_expiration_date) {
            return false;
          }
          let org_trial_expiration_date = new Date(org.trial_expiration_date)
          let filter_trial_expiration_date = new Date(this.state.filters.trial_expiration_from)

          let string_org_trial_expiration_date = this.getDateString(org_trial_expiration_date)
          org_trial_expiration_date = new Date(string_org_trial_expiration_date)

          let string_filter_trial_expiration_date = this.getDateString(filter_trial_expiration_date)
          filter_trial_expiration_date = new Date(string_filter_trial_expiration_date)

          if (org_trial_expiration_date <= filter_trial_expiration_date) {
            return true;
          }
          return false
        })
      }

      else if (this.state.filters.trial_expiration_operator == '<' && this.state.filters.trial_expiration_from) {
        organizations = organizations.filter(org => {
          if (!org.trial_expiration_date) {
            return false;
          }
          let org_trial_expiration_date = new Date(org.trial_expiration_date)
          let filter_trial_expiration_date = new Date(this.state.filters.trial_expiration_from)

          let string_org_trial_expiration_date = this.getDateString(org_trial_expiration_date)
          org_trial_expiration_date = new Date(string_org_trial_expiration_date)

          let string_filter_trial_expiration_date = this.getDateString(filter_trial_expiration_date)
          filter_trial_expiration_date = new Date(string_filter_trial_expiration_date)

          if (org_trial_expiration_date < filter_trial_expiration_date) {
            return true;
          }
          return false
        })
      }

      else if (this.state.filters.trial_expiration_operator == '>' && this.state.filters.trial_expiration_from) {
        organizations = organizations.filter(org => {
          if (!org.trial_expiration_date) {
            return false;
          }
          let org_trial_expiration_date = new Date(org.trial_expiration_date)
          let filter_trial_expiration_date = new Date(this.state.filters.trial_expiration_from)

          let string_org_trial_expiration_date = this.getDateString(org_trial_expiration_date)
          org_trial_expiration_date = new Date(string_org_trial_expiration_date)

          let string_filter_trial_expiration_date = this.getDateString(filter_trial_expiration_date)
          filter_trial_expiration_date = new Date(string_filter_trial_expiration_date)

          if (org_trial_expiration_date > filter_trial_expiration_date) {
            return true;
          }
          return false
        })
      }

      else if (this.state.filters.trial_expiration_operator == '>=' && this.state.filters.trial_expiration_from) {
        organizations = organizations.filter(org => {
          if (!org.trial_expiration_date) {
            return false;
          }
          let org_trial_expiration_date = new Date(org.trial_expiration_date)
          let filter_trial_expiration_date = new Date(this.state.filters.trial_expiration_from)

          let string_org_trial_expiration_date = this.getDateString(org_trial_expiration_date)
          org_trial_expiration_date = new Date(string_org_trial_expiration_date)

          let string_filter_trial_expiration_date = this.getDateString(filter_trial_expiration_date)
          filter_trial_expiration_date = new Date(string_filter_trial_expiration_date)

          if (org_trial_expiration_date >= filter_trial_expiration_date) {
            return true;
          }
          return false
        })
      }

      else if (this.state.filters.trial_expiration_operator == 'between' && this.state.filters.trial_expiration_from && this.state.filters.trial_expiration_to) {
        organizations = organizations.filter(org => {
          if (!org.trial_expiration_date) {
            return false;
          }
          let org_trial_expiration_date = new Date(org.trial_expiration_date)
          let trial_expiration_date_from = new Date(this.state.filters.trial_expiration_from)
          let trial_expiration_date_to = new Date(this.state.filters.trial_expiration_to)

          let string_org_trial_expiration_date = this.getDateString(org_trial_expiration_date)
          org_trial_expiration_date = new Date(string_org_trial_expiration_date)

          let string_trial_expiration_date_from = this.getDateString(trial_expiration_date_from)
          trial_expiration_date_from = new Date(string_trial_expiration_date_from)

          let string_trial_expiration_date_to = this.getDateString(trial_expiration_date_to)
          trial_expiration_date_to = new Date(string_trial_expiration_date_to)

          if (org_trial_expiration_date >= trial_expiration_date_from && org_trial_expiration_date <= trial_expiration_date_to) {
            return true;
          }
          return false
        })
      }
    }

    // account type filters
    if (this.state.filters.account_type) {
      organizations = organizations.filter(org => org.org_type == this.state.filters.account_type);
    }

    // client type filters
    if (this.state.filters.client_type) {
      organizations = organizations.filter(org => org.client_type == this.state.filters.client_type);
    }

    // locked or unlocked filters
    if (this.state.filters.locked_unlocked) {
      if (this.state.filters.locked_unlocked == 'unlocked') {
        organizations = organizations.filter(org => !org.is_locked);
      } else {
        organizations = organizations.filter(org => org.is_locked);
      }
    }

    return organizations
  }

  formatTableRows() {
    let counter = 1;
    let organizations = this.state.organizations;
    const onChange = this.onChange;
    const getOrgbyId = this.getOrgbyId;
    const viewOrgClicked = this.viewOrgClicked;
    const openDeleteOrgModal = this.openDeleteOrgModal;
    const code_options = this.state.codes;

    organizations = this.filterOrganizations(organizations)

    // this.setState({ filtered_organizations: organizations })

    const start_index =
      this.state.page === 1
        ? 0
        : this.state.entries_per_page * (this.state.page - 1);
    const end_index = this.state.entries_per_page * this.state.page;

    // change start index to 0 to stack all results per scroll to bottom
    const page_entries = organizations.slice(0, end_index);

    return page_entries.map((organization) => {
      const parent_org = getOrgbyId(organization.parent_org);
      let code = code_options.find((code) => {
        return parseToInt(code.id) === parseToInt(organization.clinician_id);
      });
      code = code ? code.code : "";

      let org_type = null;
      switch(organization.org_type) {
        case 'super_org': { org_type = settings.app_constants.superOrg.label; break; }
        case 'sub_org': { org_type = settings.app_constants.subOrg.label; break; }
        case 'standard_org': { org_type = settings.app_constants.standardOrg.label; break; }
        case 'trial_org': { org_type = settings.app_constants.trialOrg.label; break; }
        case 'free': { org_type = settings.app_constants.freeOrg.label; break; }
        case 'student': { org_type = settings.app_constants.studentOrg.label; break; }
        case 'individual': { org_type = settings.app_constants.individualOrg.label; break; }
        default: { break; }
      }

      let client_type = null;
      switch(organization.client_type) {
        case 'white_label_vpc': { client_type = settings.app_constants.clientTypes.white_label_vpc.label; break; }
        case 'white_label_multi_tenant': { client_type = settings.app_constants.clientTypes.white_label_multi_tenant.label; break; }
        case 'standard': { client_type = settings.app_constants.clientTypes.standard.label; break; }
        default: { break; }
      }

      return (
        <tr
          key={organization.id}
          className={counter++ % 2 === 0 ? "even" : "odd"}
        >
          {/* columns, need to be a state */}
          {this.state.columns.map((column) => {
            if (column.value == "account_name"){
              return <td>{organization.org_name}</td>
            }
            else if (column.value == "clinician_code"){
              return <td>{code}</td>
            }
            else if (column.value == "account_type"){
              return <td>{org_type}</td>
            }
            else if (column.value == "renewal_date"){
              // yyyy-mm-dd format (for now)
              let renewal_date = new Date(organization.renewal_date)
              let string_renewal_date = this.getDateString(renewal_date)
              return <td>{organization.renewal_date && moment(string_renewal_date).format(this.getLocaleDateString())}</td>
            }
            else if (column.value == "renewal_amount") {
              if (!organization.renewal_amount) {
                return <td></td>
              }
              return <td>${organization.renewal_amount}</td>
            }
            else if (column.value == "lock"){
              return <td className="middle">
                <div className="checkbox no-margin">
                  <label className="switch">
                    <input
                      name={organization.id}
                      id={organization.id}
                      type="checkbox"
                      checked={organization.is_locked}
                      onChange={onChange}
                    />
                    <span className="slider round"></span>
                  </label>
                </div>
              </td>
            }
            else if (column.value == "parent_org"){
              return <td>
                {organization.org_type === settings.app_constants.subOrg.value &&
                  parent_org
                  ? parent_org.org_name
                  : ""}
              </td>
            }
            else if (column.value == "licenses"){
              return <td>{organization.number_of_licenses}</td>
            }
            else if (column.value == "pedigrees"){
              return <td>{organization.pedigrees}</td>
            }
            else if (column.value == "contract_date"){
              let contract_date = new Date(organization.contract_start_date)
              let string_contract_date = this.getDateString(contract_date)
              return <td>{organization.contract_start_date && moment(string_contract_date).format(this.getLocaleDateString())}</td>
            }
            else if (column.value == "specialty"){
              return <td>{organization.specialty}</td>
            }
            else if (column.value == "client_type"){
              return <td>{client_type}</td>
            }
            else if (column.value == "trial_expiration_date") {
              let trial_expiration_date = new Date( organization.trial_expiration_date ? organization.trial_expiration_date.replace(/-/g, '\/') : "");
              let string_trial_expiration_date = this.getDateString(trial_expiration_date)
              return <td>{organization.trial_expiration_date && moment(string_trial_expiration_date).format(this.getLocaleDateString())}</td>
            }
          })}


          <td className="middle">
            <button
              className="btn btn-teal table-btn-edit margin-right-six"
              type="button"
              onClick={viewOrgClicked}
              name={organization.id}
            >
              <i className="fa fa-eye"></i>View
            </button>
            <button
              className="btn btn-light-outline table-btn-edit"
              type="button"
              onClick={openDeleteOrgModal}
              name={organization.id}
            >
              <i className="fa fa-trash"></i>Delete
            </button>
          </td>
        </tr>
      );
    });
  }

  filterValues(value) {
    this.setState({ entries_per_page: value, page: 1 });
  }

  async onSearchSubmit(search) {
    // TODO: implement client side search
    if (search === null || search === undefined || search === "") {
      this.fetchData();
    } else {
      try {
        let organizations = await account_api.search_organizations(search);
        organizations = organizations.filter(
          (org) => org.org_type !== "super_admin"
        );
        this.setState({ organizations });
      } catch (error) {
        // TODO: show error message
        console.log(error);
      }
    }
  }

  onEditColumns(columns, all_columns){
    this.setState({ columns: columns, allColumns: all_columns})
  }

  downloadCSV() {
    let csv = "";
    csv += "Name,Clinician Code,Account Type,Renewal Date,Organization Locked,Parent Organization,Licenses,Pedigrees,Contract Date,Specialty,Client Type,Trial Expiration Date\r\n";

    let organizations = this.state.organizations;
    organizations = this.filterOrganizations(organizations)

    organizations.forEach((organization) => {
      const org_name = organization.org_name;

      const code = this.state.codes.find((code) => {
        return parseToInt(code.id) === parseToInt(organization.clinician_id);
      });
      let clinician_code = "";
      if (code) clinician_code = code.code;

      const parent_org = this.getOrgbyId(organization.parent_org);
      let parent_org_name = "";
      if (parent_org) {
        parent_org_name = parent_org.org_name;
      }

      let org_type = '';
      switch(organization.org_type) {
        case 'super_org': { org_type = settings.app_constants.superOrg.label; break; }
        case 'sub_org': { org_type = settings.app_constants.subOrg.label; break; }
        case 'standard_org': { org_type = settings.app_constants.standardOrg.label; break; }
        case 'trial_org': { org_type = settings.app_constants.trialOrg.label; break; }
        case 'free': { org_type = settings.app_constants.freeOrg.label; break; }
        case 'student': { org_type = settings.app_constants.studentOrg.label; break; }
        case 'individual': { org_type = settings.app_constants.individualOrg.label; break; }
        default: { break; }
      }

      let client_type = '';
      switch(organization.client_type) {
        case 'white_label_vpc': { client_type = settings.app_constants.clientTypes.white_label_vpc.label; break; }
        case 'white_label_multi_tenant': { client_type = settings.app_constants.clientTypes.white_label_multi_tenant.label; break; }
        case 'standard': { client_type = settings.app_constants.clientTypes.standard.label; break; }
        default: { break; }
      }

      let renewal_date = new Date(organization.renewal_date)
      let string_renewal_date = this.getDateString(renewal_date)
      string_renewal_date = organization.renewal_date && moment(string_renewal_date).format(this.getLocaleDateString())
      string_renewal_date = string_renewal_date ? string_renewal_date : ''

      let renewal_amount = organization.renewal_amount
      renewal_amount = renewal_amount ? renewal_amount : ''

      let parent_org_string = organization.org_type === settings.app_constants.subOrg.value &&
        parent_org
        ? parent_org.org_name
        : ""

      let number_of_licenses = organization.number_of_licenses
      number_of_licenses = number_of_licenses ? number_of_licenses : ''

      let pedigrees = organization.pedigrees

      let contract_date = new Date(organization.contract_start_date)
      let string_contract_date = this.getDateString(contract_date)
      string_contract_date = organization.contract_start_date && moment(string_contract_date).format(this.getLocaleDateString())
      string_contract_date = string_contract_date ? string_contract_date : ''

      let specialty = organization.specialty
      specialty = specialty ? specialty : ''

      let trial_expiration_date = new Date( organization.trial_expiration_date ? organization.trial_expiration_date.replace(/-/g, '\/') : "");
      let string_trial_expiration_date = this.getDateString(trial_expiration_date)
      string_trial_expiration_date = organization.trial_expiration_date && moment(string_trial_expiration_date).format(this.getLocaleDateString())
      string_trial_expiration_date = string_trial_expiration_date ? string_trial_expiration_date : ''

      const organization_locked = organization.is_locked ? "Yes" : "No";
      const line = `${org_name},${clinician_code},${org_type},${string_renewal_date},${renewal_amount},${organization_locked},${parent_org_string},${number_of_licenses},${pedigrees},${string_contract_date},${specialty},${client_type},${string_trial_expiration_date}\r\n`;
      csv += line;
    });

    var downloadLink = document.createElement("a");
    var blob = new Blob(["\ufeff", csv]);
    var url = URL.createObjectURL(blob);
    downloadLink.href = url;
    downloadLink.download = "data.csv";

    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  }

  setAccountFilters(filters){
    this.setState({ filters })
  }

  handleReorderColumns(columns, all_columns) {
    this.setState({ columns: columns, allColumns: all_columns})
  }

  setShowSaveReportModal(show_save_report_modal){
    this.setState({ show_save_report_modal })
  }

  ciEquals(a, b) {
    return typeof a === 'string' && typeof b === 'string'
      ? a.localeCompare(b, undefined, { sensitivity: 'accent' }) === 0
      : a === b;
  }

  openOverwriteReportModal(reportTitle){
    this.setState({ show_overwrite_report: [true, reportTitle] });
  }

  closeOverwriteReportModal(){
    this.setState({ show_overwrite_report: [false, ''] });
  }

  async saveNewReport(reportTitle) {
    let reports = this.state.reports.filter(report => this.ciEquals(report.title, reportTitle));
    if (reports.length > 0) {
      this.openOverwriteReportModal(reportTitle);
    }
    else {
      this.setState({ loading: true })

      const payload = {
        filters: {
          ...this.state.filters,
          search: this.props.searchFilter.search_text
        },
        reportTitle: reportTitle,
        columns: this.state.allColumns,
        user_id: this.props.session.user.user_id
      }

      try {
        await account_api.save_new_query_report(payload, this.props.session.user.account_id)
        this.setShowSaveReportModal(false);

      } catch (error) {
        console.log(error)
      }

      helpers.delay(.2)
      this.fetchReports()
      this.setState({loading: false})
    }
  }

  async overWriteReport(reportTitle){
    this.setState({ loading: true })
    const payload = {
      filters: {
        ...this.state.filters,
        search: this.props.searchFilter.search_text
      },
      reportTitle: reportTitle,
      columns: this.state.allColumns,
      user_id: this.props.session.user.user_id
    }

    try {
      await account_api.overwrite_report(payload, this.props.session.user.account_id)
      this.setShowSaveReportModal(false);

    } catch (error) {
      console.log(error);
    }

    helpers.delay(.2);
    this.fetchReports();
    this.setState({loading: false});
  }

  openDeleteReportModal(report){
    this.setState({ show_delete_report_modal: [true, report] });
  }

  handleClearFilter(){
    this.setState({ filter: init_filter_state })
  }

  loadReport = async (report) => {
    this.setState({ loading: true })
    if (report == null) {
      this.handleClearFilter();
      this.accountFiltersRef.current.loadReportSetFilters(init_filter_state)
      this.loadDefaultColumns();
    } else {
      try {
        let report_data = await account_api.load_report(report, this.props.session.user.account_id);
        let filters = report_data.filters
        let columns = report_data.columns
        // const payload = {
        //   search: filters.search_text,
        //   gender: filters.gender,
        //   diseases: filters.diseases,
        //   referrals: filters.referrals,
        //   genes: filters.genes,
        //   more_filters: filters.more_filters,
        //   dob: filters.dob,
        //   age: filters.age,
        //   clinician: this.state.clinician
        // };

        // let probands = await family_api.query_probands(
        //   this.props.user.clinician_id, payload
        // );
        // let selected_columns = columns.filter(item => item.checked)
        // this.addDiseasesToProband(probands.members, probands.member_diseases)
        // this.addGenesToProband(probands.members, probands.member_genes)
        // this.addReferralCriteriasToProband(probands.members, probands.member_referral_criteria)
        let selected_columns = columns.filter(item => item.checked)
        this.setState({
          filters,
          columns: selected_columns,
          allColumns: columns
        });

        this.accountFiltersRef.current.loadReportSetFilters(filters)
      }
      catch (error) {
        console.log(error)
      }
    }

    this.setState({ loading: false })

  }

  async deleteReport() {
    this.setState({loading: true})
    try {
      await account_api.delete_report(this.state.show_delete_report_modal[1].value, this.props.session.user.account_id);
      await this.fetchReports();
      if(this.state.show_delete_report_modal[1].value === this.tableFilterRef.current.state.currentActiveReport.value || this.tableFilterRef.current.state.currentActiveReport.value === null){
        await this.tableFilterRef.current.selectCompRef.select.clearValue();
        await this.handleClearFilter();
      }
      this.setState({loading: false})
      this.setState({ show_delete_report_modal: [false, '']});
    }
    catch (error) {
      console.log(error)
    }

  }

  copyText() {

    let table = document.getElementById('famhis-accounts-table');
    let range, sel;
    let updatedTable = table.cloneNode(true)
    updatedTable.id = 'famhis-admin-copy-table'
    let removeButtons = updatedTable.getElementsByClassName('middle')
    while (removeButtons[0]) {
      removeButtons[0].parentNode.removeChild(removeButtons[0])
    }
    document.body.appendChild(updatedTable)

    //set width so it fits on portrait mode when pasted in word
    document.getElementById('famhis-admin-copy-table').style.width = '100px';

    if (document.createRange && window.getSelection) {
      range = document.createRange();
      sel = window.getSelection();
      sel.removeAllRanges();

      try {
        range.selectNodeContents(updatedTable);
        sel.addRange(range);
      } catch (e) {
        console.log(e)
      }
      document.execCommand('copy');
      document.body.removeChild(updatedTable)
    }
    sel.removeAllRanges();

  }

  async onSavePDF() {
    var doc = new jsPDF({
      orientation: 'landscape',
      floatPrecision: "smart",
      unit: 'px'
    });
    let headers = []
    let rows = []
    let headersData = this.state.columns.forEach((item) => {
      headers.push(item)
    })

    headers = createHeaders(headers)
    function createHeaders(keys) {
      return keys.map(key => ({
        dataKey: key.value,
        header: key.label,
      }));
    };

    const code_options = this.state.codes;

    //include for referral criteria here
    let organizations = this.state.organizations;
    organizations = this.filterOrganizations(organizations)

    organizations.forEach((organization) => {

      const parent_org = this.getOrgbyId(organization.parent_org);
      let code = code_options.find((code) => {
        return parseToInt(code.id) === parseToInt(organization.clinician_id);
      });
      code = code ? code.code : "";

      let org_type = null;
      switch(organization.org_type) {
        case 'super_org': { org_type = settings.app_constants.superOrg.label; break; }
        case 'sub_org': { org_type = settings.app_constants.subOrg.label; break; }
        case 'standard_org': { org_type = settings.app_constants.standardOrg.label; break; }
        case 'trial_org': { org_type = settings.app_constants.trialOrg.label; break; }
        case 'free': { org_type = settings.app_constants.freeOrg.label; break; }
        case 'student': { org_type = settings.app_constants.studentOrg.label; break; }
        case 'individual': { org_type = settings.app_constants.individualOrg.label; break; }
        default: { break; }
      }

      let client_type = null;
      switch(organization.client_type) {
        case 'white_label_vpc': { client_type = settings.app_constants.clientTypes.white_label_vpc.label; break; }
        case 'white_label_multi_tenant': { client_type = settings.app_constants.clientTypes.white_label_multi_tenant.label; break; }
        case 'standard': { client_type = settings.app_constants.clientTypes.standard.label; break; }
        default: { break; }
      }

      let org_name = organization.org_name
      let renewal_date = new Date(organization.renewal_date)
      let string_renewal_date = this.getDateString(renewal_date)
      string_renewal_date = organization.renewal_date && moment(string_renewal_date).format(this.getLocaleDateString())

      let renewal_amount = organization.renewal_amount
      renewal_amount = renewal_amount ? renewal_amount : ''

      let parent_org_string = organization.org_type === settings.app_constants.subOrg.value &&
        parent_org
        ? parent_org.org_name
        : ""

      let number_of_licenses = organization.number_of_licenses

      let pedigrees = organization.pedigrees

      let contract_date = new Date(organization.contract_start_date)
      let string_contract_date = this.getDateString(contract_date)
      string_contract_date = organization.contract_start_date && moment(string_contract_date).format(this.getLocaleDateString())

      let specialty = organization.specialty

      let trial_expiration_date = new Date( organization.trial_expiration_date ? organization.trial_expiration_date.replace(/-/g, '\/') : "");
      let string_trial_expiration_date = this.getDateString(trial_expiration_date)
      string_trial_expiration_date = organization.trial_expiration_date && moment(string_trial_expiration_date).format(this.getLocaleDateString())

      let row = {
        account_name: org_name,
        clinician_code: code,
        account_type: org_type,
        renewal_date: string_renewal_date,
        renewal_amount: renewal_amount,
        parent_org: parent_org_string,
        licenses: number_of_licenses,
        pedigrees,
        contract_date: string_contract_date,
        specialty,
        client_type,
        trial_expiration_date: string_trial_expiration_date
      }
      rows.push(row)
    });

    doc.autoTable({
      columns: headers,
      body: rows,
      bodyStyles: { fontSize: 11, valign: 'middle'},
      styles:{valign: 'bottom', minCellWidth: 50},

    })
    doc.save('accounts-data.pdf')
  }

  render() {
    const tableRows = this.formatTableRows();

    return (
      <React.Fragment>
        <NavTop
          history={this.props.history}
          onSearchSubmit={(search) => this.onSearchSubmit(search)}
        />

        <section
          className="wow fadeIn section animated"
          style={{ visibility: "visible", animationName: "fadeIn" }}
        >
          <div className="container">
            <TableFilter
              ref={this.tableFilterRef}
              filterValues={(value) => this.filterValues(value)}
              onSearchSubmit={(search) => this.onSearchSubmit(search)}
              downloadCSV={this.downloadCSV}
              setShowSaveReportModal={this.setShowSaveReportModal}
              reports={this.state.reports}
              openDeleteReportModal={(report)=> this.openDeleteReportModal(report)}
              loadReport={(report)=>this.loadReport(report)}
            />

            <AccountFiltersContainer
              ref={this.accountFiltersRef}
              famhis_admin={true}
              recordsCount={this.state.organizations.length}
              organizations={this.state.organizations}
              downloadCSV={this.downloadCSV}
              setAccountFilters={(filters) => this.setAccountFilters(filters)}
              columns={this.state.columns}
              allColumns={this.state.allColumns}
              onEditColumns={(columns, all_columns) => this.onEditColumns(columns, all_columns)}
              onRearrangeColumn={(columns, all_columns) => this.handleReorderColumns(columns, all_columns)}
              onCopy={this.copyText}
              savePDF={this.onSavePDF}
            />

            {this.state.deleteErrorMessage && (
              <div className="alert alert-danger">
                {this.state.deleteErrorMessage}
              </div>
            )}

            <br /> <br /> <br />

            <table id="famhis-accounts-table" className="table table-custom">
              <thead>
                  <tr>
                      {/* columns, need to be a state */}
                      {this.state.columns.map((column, index) => {
                        if (column.value == "lock"){
                          return <th key={createUUID()}>{column.label}</th>
                        }
                        else{
                          return <>
                            {<th onClick={() => { this.handleColumnHeaderClick(column.value) }} style={{ cursor: 'pointer' }}>{column.label}<span style={{ float: 'right', fontSize: '14px' }}>
                              {this.state.sortingState.clicks == 1 && this.state.sortingState.column == column.value ? <i class="fa fa-lg fa-angle-down"></i>
                                : this.state.sortingState.clicks == 2 && this.state.sortingState.column == column.value ? <i class="fa fa-solid fa-lg fa-angle-up"></i> : null}
                            </span></th>}
                          </>
                        }
                      })}



                      {/* {<th onClick={() => {this.handleColumnHeaderClick(3)}} style={{cursor: 'pointer'}}>Parent Org<span style={{float: 'right', fontSize: '14px'}}>
                        {this.state.sortingState.clicks == 1 && this.state.sortingState.column == 3 ? <i class="fa fa-solid fa-lg fa-angle-down"></i>
                        : this.state.sortingState.clicks == 2 && this.state.sortingState.column == 3 ? <i class="fa fa-solid fa-lg fa-angle-up"></i> : null}
                        </span></th> } */}



                  </tr>
              </thead>
              <tbody>
                {tableRows}
              </tbody>
            </table>

            {/* {this.state.organizations.length > 0 && (
              <TableFooter
                entries={this.state.organizations.length}
                entries_per_page={this.state.entries_per_page}
                page={this.state.page}
                page_change={(page) => this.setState({ page })}
              />
            )} */}
          </div>
        </section>

        {this.state.showDeleteOrgModal && (
          <ModalDeleteAccount
            orgKey={this.state.currentOrgKey}
            onClose={this.closeDeleteOrgModal}
            onClickDelete={(payload) => this.onDeleteOrg(payload)}
          />
        )}

        {this.state.show_overwrite_report[0] && (
          <ModalOverwriteReport
            onClose={this.closeOverwriteReportModal}
            reportTitle={this.state.show_overwrite_report[1]}
            onClickSave={(reportTitle) => this.overWriteReport(reportTitle)}
          />
        )}

        {this.state.show_save_report_modal && (
          <ModalSaveReport
            onClose={() => this.setShowSaveReportModal(false)}
            onClickSave={(reportTitle) => this.saveNewReport(reportTitle)}
          />
        )}

        {this.state.show_delete_report_modal[0] && (
          <ModalConfirmReportDelete
            title="Delete Report"
            message="Are you sure you would like to delete this report?"
            isOpen={this.state.show_delete_report_modal[0]}
            onCancel={() => this.setState({ show_delete_report_modal: [false, ''] })}
            onOk={() => this.deleteReport()}
            loading={this.state.loading}
            errorMessages={[]}
          />
        )}
      </React.Fragment>
    );
  }
}

const redux_state = state => ({
  session: state.session,
  searchFilter: state.search.searchFilter,
});

const redux_actions = dispatch => ({
  dispatch: action => dispatch(action)
});

export default connect(
  redux_state,
  redux_actions
)(AccountsPage);
